import React from "react";
import filterTypes from "components/Table/filterTypes";
import BasicCell from "components/Table/components/BasicCell";
import moment from "moment";
import { Button, Icon, Popup } from "semantic-ui-react";
import style from "../routes/Harvest/PackedBoxes/PackedBoxes.module.css";
import { Link } from "react-router-dom";
import { allocatedSelector } from "selectors/pallets";
export const getPalletsTableColumns = (isFetching, navigate, onDelete) => {
  const columnsConfig = {
    id: {
      withSort: true,
      type: "string",
      id: "id",
      title: "id",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ id }) => id,
      withSort: true,
      filterId: "isAllocatedToDispatch",
      filter: {
        title: "Allocated to dispatch",
        type: filterTypes.SingleSelect,
        selector: allocatedSelector,
      },
      cellWidth: 2,
    },
    createDate: {
      withSort: true,
      type: "string",
      id: "createDate",
      title: "Date",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ createDate }) => moment(createDate).format("DD/MM/YYYY"),
      withSort: true,
    },
    variety: {
      withSort: true,
      type: "string",
      id: "variety",
      title: "Variety",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ variety }) => variety?.name || "-",
      withSort: true,
    },
    boxUnit: {
      withSort: true,
      type: "string",
      id: "boxUnit",
      title: "Box unit",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ boxUnit }) => boxUnit.displayName || "-",
      withSort: true,
    },
    area: {
      withSort: true,
      type: "string",
      id: "area",
      title: "Area",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ area }) => area?.name || "-",
      withSort: true,
    },
    registrationNumber: {
      withSort: true,
      type: "string",
      id: "registrationNumber",
      title: "Registration numbers",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: (d) =>
        d?.areas
          ?.map(({ area }) => area.registrationNumber)
          .filter((n) => !!n)
          .join(", ") || "-",
      withSort: true,
    },
    unitsOnPallet: {
      withSort: false,
      type: "string",
      id: "unitsOnPallet",
      title: "Units on pallet",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ unitsOnPallet }) => unitsOnPallet || "-",
      withSort: true,
    },
    order: {
      withSort: false,
      type: "string",
      id: "order",
      title: "Dispatch id",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ dispatch }) => dispatch?.id || "-",
      withSort: true,
      cellWidth: 2,
    },
    notes: {
      withSort: true,
      type: "string",
      id: "notes",
      title: "Notese",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ notes }) => notes || "-",
      withSort: true,
      cellWidth: 2,
    },
    btnWrapper: {
      withSort: false,
      type: "string",
      id: "btnWrapper",
      title: "",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ id }) => {
        return (
          <div className={style.wrapper}>
            <div className={style.iconWrapper}>
              <Popup
                inverted
                position="bottom center"
                content={"Edit"}
                size="tiny"
                trigger={
                  <div className={style.editButtonWrapper}>
                    <Button
                      as={Link}
                      to={`/harvest/pallets/pallet/${id}`}
                      onClick={(event) => {
                        return event.stopPropagation();
                      }}
                      className={style.editButton}
                      floated="right"
                      icon={<Icon name="edit" />}
                      size="small"
                    />
                  </div>
                }
              />
              <Popup
                inverted
                position="bottom center"
                content={"Delete"}
                size="tiny"
                trigger={
                  <Button
                    onClick={(event) => {
                      return onDelete(id), event.stopPropagation();
                    }}
                    className={style.deleteButton}
                    floated="right"
                    icon={<Icon name="trash alternate" />}
                    size="small"
                  />
                }
              />
            </div>
          </div>
        );
      },
      withSort: true,
      cellWidth: 2,
    },
  };

  return Object.entries(columnsConfig).map(([id, targetColumn]) => ({
    id,
    ...targetColumn,
    accessor: targetColumn.accessor || id,
    Header: targetColumn.title,
    Cell: targetColumn.Cell || BasicCell,
    ...(targetColumn.sortFields ? { sortFields: targetColumn.sortFields } : {}),
    ...(targetColumn.filter ? { filter: targetColumn.filter } : {}),
  }));
};
